module.exports = __webpack_public_path__ + "img/cuco-bom-full.f5831fd1.svg";